import React, { useState } from 'react';
import Swal from 'sweetalert2';

function Contact() {
  const [formValues, setFormValues] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  // const API_BASE_URL = 'http://dev.mydomain.com:3001'; // Replace port as needed

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    Swal.fire('Success', 'Email sent successfully', 'success');
    // Reset the form after successful submission
    setFormValues({
      name: '',
      email: '',
      subject: '',
      message: '',
    });
    // try {
    //   const response = await fetch(`${API_BASE_URL}/send-email`, {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify(formValues),
    //   });

    //   if (response.ok) {
    //     Swal.fire('Success', 'Email sent successfully', 'success');
    //     // Reset the form after successful submission
    //     setFormValues({
    //       name: '',
    //       email: '',
    //       subject: '',
    //       message: '',
    //     });
    //   } else {
    //     Swal.fire('Error', 'Error sending email', 'error');
    //   }
    // } catch (error) {
    //   console.error('Error:', error);
    //   Swal.fire('Error', 'An error occurred', 'error');
    // }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  return (
    <div className="w-[100%] lg:max-w-7xl bg-black ml-1 lg:mt-10 py-8 mx-auto">
      <div className=" mx-auto px-4 lg:px-20">
        <div className="text-center mb-12">
          
          <h6 className="text-5xl font-semibold   text-white mb-3">Get in touch</h6>
          <p className="text-gray-500">Our friendly team would love to hear from you.</p>
        </div>
        <div className="flex flex-wrap -mx-4">
          <div className="w-full lg:w-1/2 px-4 mb-8 lg:mb-0">
            <form className="contact-form bg-white p-8 lg:h-full rounded-lg shadow-lg" onSubmit={handleSubmit}>
              <div className="flex flex-wrap -mx-4 mb-6">
                <div className="w-full lg:w-1/2 px-4 mb-4 lg:mb-0">
                  <label htmlFor="name" className="block text-sm font-semibold text-gray-700">First Name:</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formValues.name}
                    onChange={handleChange}
                    placeholder="Your name"
                    required
                    className="bg-slate-300 w-[80%] lg:w-full mt-2   border-2  px-1 lg:px-1 lg:h-12 border-red-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div className="w-full lg:w-1/2 px-4">
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-700">Your Email:</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formValues.email}
                    onChange={handleChange}
                    placeholder="Your email"
                    required
                    className="bg-slate-300 w-[80%] lg:w-full mt-2   border-2  px-1 lg:px-1 lg:h-12 border-red-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
              <div className="mb-6">
                <label htmlFor="subject" className="block text-sm font-semibold text-gray-700">Subject:</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formValues.subject}
                  onChange={handleChange}
                  placeholder="Subject"
                  required
                  className="bg-slate-300 w-[80%] lg:w-full mt-2   border-2  px-1 lg:px-1 lg:h-12 border-red-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="mb-6">
                <label htmlFor="message" className="block text-sm font-semibold text-gray-700">Message:</label>
                <textarea
                  id="message"
                  name="message"
                  value={formValues.message}
                  onChange={handleChange}
                  rows="5"
                  placeholder="Your message"
                  required
                  className="bg-slate-300  w-[80%] lg:w-full mt-2 py-12 border-4  border-red-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full lg:py-6 mt-12 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-lg font-semibold hover:from-purple-500 hover:to-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-300"
              >
                Send Message
              </button>
            </form>
          </div>
          <div className="w-[100%] lg:w-1/2 px-4 flex flex-col items-center justify-center">
            <img
              src="/images/FAYSAL1.jpg"
              alt="Contact"
              className="w-80 h-64 mb-8 rounded-lg shadow-lg object-cover"
            />
            <ul className="contact-infos space-y-4">
              <li className="flex items-center">
                <div className="icon bg-gradient-to-r from-green-400 to-blue-500 p-2 rounded-full text-white">
                  <i className="fas fa-phone-alt"></i>
                </div>
                <div className="ml-4">
                  <h5 className="text-sm lg:text-lg font-semibold text-gray-700">Phone</h5>
                  <p className="text-gray-500">+01629921913</p>
                </div>
              </li>
              <li className="flex items-center">
                <div className="icon bg-gradient-to-r from-red-400 to-yellow-500 p-2 rounded-full text-white">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="ml-4">
                  <h5 className="text-sm lg:text-lg font-semibold text-gray-700">Mail</h5>
                  <p className="text-gray-500">musnud1234@gmail.com</p>
                </div>
              </li>
              <li className="flex items-center">
                <div className="icon bg-gradient-to-r from-purple-400 to-pink-500 p-2 rounded-full text-white">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="ml-4">
                  <h5 className="text-sm lg:text-lg font-semibold text-gray-700">Visit My Studio</h5>
                  <p className="text-gray-500">
                   Mirpur-10, Dhaka,1216
                  </p>
                </div>
                
              </li>
              <li className="flex items-center">
                <div className="icon bg-gradient-to-r from-blue-500 to-purple-500 p-2 rounded-full text-white">
                  <a href="https://www.linkedin.com/in/musnud-billah-faysal/" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </div>
                <div className="ml-4">
                  <h5 className="text-sm lg:text-lg font-semibold text-gray-700">LinkedIn</h5>
                  <p className="text-gray-500">https://www.linkedin.com/in/musnud-billah-faysal/</p>
                </div>
              </li>
              <li className="flex items-center">
                <div className="icon bg-gradient-to-r from-black to-gray-500 p-2 rounded-full text-white">
                  <a href="https://github.com/Faysalgreen35" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-github"></i>
                  </a>
                </div>
                <div className="ml-4">
                  <h5 className="text-sm lg:text-lg font-semibold text-gray-700">GitHub</h5>
                  <p className="text-gray-500">https://github.com/Faysalgreen35</p>
                </div>
              </li>
              <li className="flex items-center">
                <div className="icon bg-gradient-to-r from-blue-600 to-blue-900 p-2 rounded-full text-white">
                  <a href="https://www.facebook.com/faysalgub35" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </div>
                <div className="ml-4">
                  <h5 className="text-sm lg:text-lg font-semibold text-gray-700">Facebook</h5>
                  <p className="text-gray-500">https://www.facebook.com/faysalgub35</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;



// import React, { useState } from 'react';

// function Contact() {
//   const [formValues, setFormValues] = useState({
//     name: '',
//     email: '',
//     subject: '',
//     message: '',
//   });

//   const API_BASE_URL = 'http://dev.mydomain.com:3001'; // Replace port as needed

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       const response = await fetch(`${API_BASE_URL}/send-email`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formValues),
//       });

//       if (response.ok) {
//         console.log('Email sent successfully');
//         // Reset the form after successful submission
//         setFormValues({
//           name: '',
//           email: '',
//           subject: '',
//           message: '',
//         });
//       } else {
//         console.log('Error sending email');
//       }
//     } catch (error) {
//       console.error('Error:', error);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormValues({
//       ...formValues,
//       [name]: value,
//     });
//   };

//   return (
//     <>
//       <div className="contact-page">
//         <div className="content-box-contact">
//           <h6 className="get-in-touch">Get in touch</h6>
//           <p>Our friendly team would love to hear from you.</p>
//           <form className="contact-form">
//             <div className="form-group-row">
//               <div className="form-group">
//                 <label htmlFor="name">First Name:</label>
//                 <input
//                   type="text"
//                   id="name"
//                   name="name"
//                   placeholder="Your name"
//                   required
//                 />
//               </div>
//               <div className="form-group">
//                 <label htmlFor="email">Your Email12/label>
//                 <input
//                   type="email"
//                   id="email"
//                   name="email"
//                   placeholder="Your email"
//                   required
//                 />
//               </div>
//             </div>
//             <div className="form-group-1">
//               <label htmlFor="subject">Subject:</label>
//               <br />
//               <input
//                 type="text"
//                 id="subject"
//                 name="subject"
//                 placeholder="Subject"
//                 required
//               />
//             </div>
//             <div className="form-group-2">
//               <label htmlFor="message">Message:</label>
//               <br />
//               <textarea
//                 id="message"
//                 name="message"
//                 rows="5"
//                 placeholder="Your message"
//                 required
//               ></textarea>
//             </div>
//             <div className="send-message button">
//               <button
//                 className="send-message button"
//                 type="button" // Change "type" attribute to "button"
//                 onClick={handleSubmit} // Call the handleSubmit function on click
//               >
//                 Send Message
//               </button>
//             </div>
//           </form>
//         </div>
//         <div className="image-contact">
//           <img
//            src="/images/faysal5.jpg"
//             alt="mage"
//             className="w-64 h-333"
//           />

//           <ul className="contact-infos">
//             <li>
//               <div className="icon bg-1">
//                 <i className="fas fa-phone-alt"></i>
//               </div>
//               <div className="col">
//                 <h5>Phone</h5>
//                 <p>+01 123 654 8096</p>
//               </div>
//             </li>
//             <li>
//               <div className="icon bg-2">
//                 <i className="fas fa-envelope"></i>
//               </div>
//               <div className="col">
//                 <h5>Mail</h5>
//                 <p>info@domainname.com</p>
//               </div>
//             </li>
//             <li>
//               <div className="icon bg-3">
//                 <i className="fas fa-map-marker-alt"></i>
//               </div>
//               <div className="col">
//                 <h5>Visit My Studio</h5>
//                 <p>
//                   Warnwe Park Streetperrine, <br />
//                   FL 33157 New York City
//                 </p>
//               </div>
//             </li>
//           </ul>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Contact;
